import { TextBadge } from '@carvana/ds-badge';
import { decorative } from '@carvana/ds-styles';
import { setSearchViewed } from '@carvana/merch-search-bar/utils/savedSearchNotifications';
import { ChevronRight } from 'lucide-react';
import { addNewestInventorySortToCvnaId } from '@/home/ReturnUser/RecentSearches/RecentSearches';
import { SavedSearch } from '~/contracts/common';
import { RecentSearch } from '~/contracts/home';
import useGetConsumerHref from '~/hooks/common/selectors/useGetConsumerHref';
import { nativeSrpPayload } from '~/native/common/utils';
import {
  ChevronWrapper,
  Copy,
  Link,
  LinkName,
  SubWrapper,
  UpperWrapper
} from './SRPLinks.styles';

type SearchLinkProps =
  | {
      link: SavedSearch;
      type: 'saved';
    }
  | {
      link: RecentSearch;
      type: 'recent';
    };

export default function SearchLink({ link, type }: SearchLinkProps) {
  const getHref = useGetConsumerHref();

  const displayName =
    type === 'saved' ? link.name : link.savedSearch?.name ?? link.display.name;

  const totalNewVehicles = link.totalNewVehicles ?? 0;
  const totalMatchingVehicles = link.totalMatchingVehicles ?? 0;

  return (
    <Link
      data-analytics-id="Home feed card"
      data-analytics-attributes={JSON.stringify({
        description: 'Search Card',
        type,
        item: 'search'
      })}
      data-native-payload={nativeSrpPayload}
      data-testid={`${type}-search-links`}
      href={getHref(
        `/cars/filters?cvnaid=${addNewestInventorySortToCvnaId(link.cvnaId)}`
      )}
      onClick={
        type === 'saved' ? () => setSearchViewed(link.cvnaId) : undefined
      }
    >
      <UpperWrapper>
        <LinkName title={displayName}>{displayName}</LinkName>
        {(totalMatchingVehicles >= 0 || totalNewVehicles > 0) && (
          <SubWrapper>
            {totalMatchingVehicles >= 0 && (
              <Copy data-testid="saved-search-results-count">
                {totalMatchingVehicles.toLocaleString()} results
              </Copy>
            )}
            {totalNewVehicles > 0 && (
              <TextBadge
                customBorderColor={decorative['4Strong']}
                priority="custom"
                variant="outline"
              >
                {totalNewVehicles.toLocaleString()} New
              </TextBadge>
            )}
          </SubWrapper>
        )}
      </UpperWrapper>
      <ChevronWrapper>
        <ChevronRight
          aria-hidden="true"
          size={32}
          className="text-icon-strong group-hover:text-icon-strong-hover"
        />
      </ChevronWrapper>
    </Link>
  );
}
